import { FC, useMemo } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Flex } from 'antd';
import { createColumnHelper } from '@tanstack/react-table';
import translations from './RoleAccessGroupTable.translations.json';
import { Table, AccessGroupDto, TextEllipsis } from '@atlas-frontend/sdk';
import { UiLink } from '../../paths/UiLink';
import { path } from '../../paths';

const { addTranslations, useTranslation } = i18nNsFactory(
  'role-access-group-table'
);
addTranslations(translations);

const columnHelper = createColumnHelper<AccessGroupDto>();

export type RoleAccessGroupTableProps = {
  accessGroups: AccessGroupDto[];
};

export const RoleAccessGroupTable: FC<RoleAccessGroupTableProps> = (props) => {
  const { accessGroups } = props;
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: t('column.name'),
        enableSorting: false,
        cell: (props) => (
          <TextEllipsis>
            <UiLink
              id={`role-access-group-${props.row.index}`}
              path={path.accessGroupDetails}
              params={{ id: props.row.original.id }}
              target="_blank"
            >
              {props.renderValue()}
            </UiLink>
          </TextEllipsis>
        ),
      }),
    ],
    [t]
  );

  return (
    <Flex align="end" gap="middle" vertical>
      <Table
        name="role-access-group-table"
        data={accessGroups}
        columns={columns}
        sticky
        virtual
        scrollContainerSelector="#detail-layout-main-content"
      />
    </Flex>
  );
};
